import React from 'react';
import { Box, Typography, Button, Paper, Modal } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const ModalSucesso = ({ open, onClose, message }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-title" aria-describedby="modal-description">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            textAlign: 'center',
            maxWidth: 400,
          }}
        >
          <CheckCircleOutlineIcon sx={{ fontSize: 48, color: '#4caf50', marginBottom: 2 }} />
          <Typography id="modal-title" variant="h5" component="h1" gutterBottom>
            Sucesso!
          </Typography>
          <Typography id="modal-description" variant="body1" color="textSecondary" sx={{ marginBottom: 3 }}>
            {message}
          </Typography>
          <Button variant="contained" color="primary" onClick={onClose}>
            Ok
          </Button>
        </Paper>
      </Box>
    </Modal>
  );
};

export default ModalSucesso;